import { T as u } from "../index-phH08dZT.js";
const L = ({
  gtm4Map: c = {},
  gtm3Map: a = {}
}) => {
  function s(t, n) {
    return c[t] ? c[t](n) : a[t] ? a[t](n) : !1;
  }
  function m(t, n = {}) {
    const { gtmId: e } = (t == null ? void 0 : t.meta) || {}, o = (d) => typeof d != "function", r = s(e, n);
    if (!r) return !1;
    const v = o(r) ? { ...r } : r(n);
    if (!v.pageName) return !1;
    const { pageName: G, ...k } = v;
    return u.trackPage(G, k), !0;
  }
  function i(t, n, e, o) {
    if (t[n]) {
      const r = t[n](e);
      r && u.trackEvent({
        event: o,
        ...r
      });
    }
  }
  function f(t, n = {}) {
    i(a, t, n, "GAevent"), i(c, t, n, "GA4event");
  }
  return { getGtmId: s, trackPage: m, trackEventByGtmMap: i, trackEvent: f, trackingDirective: {
    beforeMount: (t, n) => {
      const { dir: e } = n;
      e.updated(t, n), t.addEventListener(
        "click",
        t.vGtmListener = () => {
          t.vGtmId && f(t.vGtmId, t.vGtmParams);
        }
      );
    },
    updated: (t, { arg: n = {}, value: e = "" }) => {
      t.vGtmId = e, t.vGtmParams = n;
    },
    unmounted: (t) => t.removeEventListener("click", t.vGtmListener)
  } };
};
export {
  L as analyticsFactory
};
//# sourceMappingURL=analyticsFactory.js.map
